export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/062e30a7ac6b62636e98a277a6442dbf.svg";